export function openCareer() {
        // Event-Handler für jeden Button im Slider
        $('.swiper-wrapper').on('click', '.wp-block-button__link', function (event) {
            event.preventDefault();
            var $thisSlide = $(this).closest('.swiper-slide');
            var contentHtml = $thisSlide.find('.popup-content').html(); // Holt den HTML-Inhalt
            document.body.style.overflow = 'hidden';
            $('#overlay').show(); // Zeige das Overlay

            // Setze den Inhalt in das Modal
            $('#meinModal').find('.modal-body').html(contentHtml);

            // Zeige das Modal
            $('#meinModal').show();
        });

        // Schließe das Modal beim Klick auf den Schließen-Button
        $('.close').click(function () {
            $('#meinModal').hide();
            $('#overlay').hide();
            document.body.style.overflow = 'auto';
        });

        // Schließe das Modal beim Klick außerhalb des Modal-Inhalts
        $(window).click(function (event) {
            if ($(event.target).is('.modal')) {
                $('.modal').hide();
                $('#overlay').hide();
                document.body.style.overflow = 'auto';
            }
        });
}